import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { createPendingIntent, normalizeReturnPath } from '../lib/pendingIntent';

const GDPR_DELETE_SUCCESS_KEY = 'jobmatchpro:gdpr-delete-success';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const returnPath = useMemo(
    () => normalizeReturnPath(`${location.pathname}${location.search}${location.hash}`),
    [location.pathname, location.search, location.hash],
  );
  const allowCompletedDeletion = location.pathname === '/manage-data'
    && (() => {
      if (typeof window === 'undefined') return false;
      try { return window.sessionStorage.getItem(GDPR_DELETE_SUCCESS_KEY) === '1'; } catch (_) { return false; }
    })();

  useEffect(() => {
    if (!loading && !user && !allowCompletedDeletion) {
      createPendingIntent({ kind: 'auth_return', return_path: returnPath });
    }
  }, [loading, user, returnPath, allowCompletedDeletion]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-route-loading">
        <p className="text-muted-foreground">Restoring your session…</p>
      </div>
    );
  }

  if (!user && !allowCompletedDeletion) {
    return <Navigate to={`/sign-in?return_to=${encodeURIComponent(returnPath)}`} replace />;
  }

  return children;
}
